export class HttpError extends Error {}
